import React, { useState } from 'react';
import ProgressBar from 'react-bootstrap/ProgressBar';
import CustomModal from "../../components/CustomModal/CustomModal";
import UserInfo from "../../components/UserInfo/UserInfo";
import InputUserInfo from "../../components/InputUserInfo/InputUserInfo";
import { Dropdown, Button, Spinner, Card, Row, Col, Badge, Nav } from 'react-bootstrap';
import useMediaQuery from '../../hooks/useMediaQuery';
import { ROLES } from '../../model/roles';
import UtilityService from '../../services/UtillityServices/UtilityService';
import useClassi from '../../hooks/useClassi';
import useUtenti from "../../hooks/useUtenti";
import useAttestati from '../../hooks/useAttestati';
import { alertService } from '../../services/AlertService';
import moment from 'moment';

const UsersToCourseManager = (props) => {

  const {
    users,
    openDeleteCourseModal,
    userLoggedIn,
    openUpdateStatoPagamentoModal,
    openGeneraAttestatoModal,
    isClassView = false,
    setShowFilterTable,
    openUpdateStatoFatturazioneModal,
    openSpedizioneModal,
    openVerificaModal,
    onDownloadReport,
    isDownloadingReport,
    openSelectRecipientModal,
    openPrenotaEsameModal,
    corsoSenzaEsame,
    activeTab,
    onRefreshUsers
  } = props;
  const usersArray = Array.isArray(users) ? users : [];
  const isMax500px = useMediaQuery('(max-width: 500px)');
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [percorsoFormativo, setPercorsoFormativo] = useState(null);
  const [currentView, setCurrentView] = useState('list');
  const [currentTab, setCurrentTab] = useState('contenuti');
  const [selectedUserNome, setSelectedUserNome] = useState('');
  const [selectedUserCognome, setSelectedUserCognome] = useState('');
  const { getMaterialiClasseByUserId, loadingStateClassi } = useClassi();
  const [selectedUtente, setSelectedUtente] = useState(null);

  const { stampaBustaAttestato, loadingStateAttestati } = useAttestati();
  const isPrintingEnvelope = loadingStateAttestati.isPrintingEnvelope;

  const {
    modalStateUtenti,
    setModalStateUtenti
  } = useUtenti();

  const groupUsersByRole = (usersArray) => {
    return usersArray?.reduce((groups, user) => {
      const role = user?.tipo_utente;
      if (!groups[role]) {
        groups[role] = [];
      }
      groups[role]?.push(user);
      return groups;
    }, {});
  };

  const groupedUsers = groupUsersByRole(usersArray);

  const formatRoleName = (role) => {
    switch (role) {
      case "course_designer": return "Course designers";
      case "docente": return "Docenti";
      case "tutor": return "Tutor";
      case "corsista": return "Corsisti";
      default: return "Non specificato";
    }
  };

  const getEsitoEsameBadge = (esito) => {
    switch (esito) {
      case 'promosso':
        return { bg: 'success', text: 'light' };
      case 'bocciato':
        return { bg: 'danger', text: 'light' };
      case 'non_svolto':
      default:
        return { bg: 'warning', text: 'dark' };
    }
  };

  const rolePriority = {
    "course_designer": 1,
    "docente": 2,
    "tutor": 3,
    "corsista": 4,
    "default": 5
  };

  const sortedRoles = Object.keys(groupedUsers)?.sort((a, b) => {
    return (rolePriority[a] || rolePriority.default) - (rolePriority[b] || rolePriority.default);
  });

  const openInfoModal = (user) => {
    setSelectedUtente(user);
    setModalStateUtenti((state) => ({ ...state, showModalInfoUtente: true }));
  };

  const handleCloseModal = () => {
    setModalStateUtenti((state) => ({
      ...state,
      showModalInfoUtente: false,
    }));
  };

  const handleShowPercorsoFormativo = async (id_classe, id_utente, id_classe_utente, nome, cognome) => {
    setSelectedUserNome(nome);
    setSelectedUserCognome(cognome);
    setCurrentView('percorso');

    const obj = {
      id_classe: id_classe,
      id_utente: id_utente,
      id_classe_utente: id_classe_utente
    };
    const res = await getMaterialiClasseByUserId(obj);
    setPercorsoFormativo(res);
  };

  const handleStampaBusta = async (utente) => {
        if (utente.id_attestato) {
            await stampaBustaAttestato({ id_attestato: utente.id_attestato });
        } else {
            alertService.warn("Impossibile stampare la busta: ID attestato non trovato.");
        }
    };

  const getFontePagamentoText = (pagamentoPartnerValue) => {
      switch (pagamentoPartnerValue) {
          case 1:
              return 'Corsista';
          case 2:
              return 'Partner';
          case 3:
              return 'Superpartner';
          case 0:
          default:
              return 'Non Assegnato'; // Testo da mostrare per il valore 0
      }
  };

  const renderActions = (utente) => {
    const actions = [];

    if (utente?.tipo_utente === "corsista") {
      actions.push({
        type: 'Azioni',
        icon: 'bi-person-lines-fill text-primary',
        label: 'Anagrafica',
        onClick: () => openInfoModal(utente),
        show: userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.COURSE_DESIGNER || userLoggedIn?.role === ROLES.DOCENTE || userLoggedIn?.role === ROLES.PARTNER
      });

      actions.push({
        type: 'Azioni',
        icon: 'bi-file-earmark-text text-success',
        label: 'Genera attestato',
        onClick: () => openGeneraAttestatoModal(utente),
        show: userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.COURSE_DESIGNER || userLoggedIn?.role === ROLES.DOCENTE
      });

      actions.push({
        type: 'Azioni',
        icon: 'bi bi-truck text-primary',
        label: 'Gestisci Spedizione',
        show: utente.id_attestato,
        onClick: () => openSpedizioneModal(utente)
      });

      actions.push({
        type: 'Azioni',
        icon: 'bi bi-envelope-fill text-dark',
        label: 'Stampa busta',
        show: utente.id_attestato,
        onClick: () => openSelectRecipientModal(utente), 
      });

      actions.push({
        type: 'Azioni',
        icon: 'bi-pencil text-warning',
        label: 'Modifica stato pagamento',
        onClick: () => openUpdateStatoPagamentoModal(utente),
        show: userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER
      });

      const etichettaAzioneFatturazione = utente.stato_fatturazione === 'Non_fatturato' ? 'Segna Fatturato' : 'Modifica Stato';

      actions.push({
        type: 'Azioni',
        icon: 'bi-receipt text-body',
        label: etichettaAzioneFatturazione,
        onClick: () => openUpdateStatoFatturazioneModal(utente),
        show: userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER
      });

      actions.push({
        type: 'Azioni',
        icon: 'bi-shield-check text-info',
        label: 'Verifica Amministrativa',
        onClick: () => openVerificaModal(utente),
        show: userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER
      });

      actions.push({
        type: 'Azioni',
        icon: 'bi-file-earmark-pdf text-danger',
        label: 'Scarica Report Attività',
        onClick: () => onDownloadReport(utente),
        show: userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.PARTNER
      });

      // Pulsante prenotazione esame (solo per corsi con esame, solo per corsisti, e solo nella tab "inAttesaEsame")
      // NON mostrare se l'utente ha già una prenotazione attiva
      const hasPrenotazioneAttiva = utente?.prenotazione_esame && utente.prenotazione_esame.prenotato === 1;
      actions.push({
        type: 'Azioni',
        icon: 'bi-calendar-check text-primary',
        label: 'Prenota Esame',
        onClick: () => openPrenotaEsameModal && openPrenotaEsameModal(utente),
        show: !corsoSenzaEsame && 
              utente.tipo_utente === 'corsista' && 
              activeTab === 'inAttesaEsame' &&
              !hasPrenotazioneAttiva &&
              (userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.COURSE_DESIGNER || userLoggedIn?.role === ROLES.DOCENTE)
      });
    }

    actions.push({
      type: 'Azioni',
      icon: 'bi-x-circle-fill text-danger',
      label: isClassView ? 'Rimuovi dalla classe' : 'Rimuovi dal corso',
      onClick: () => openDeleteCourseModal(utente),
      show: (userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER)
    }); 

    const visibleActions = actions.filter(action => action.show);

    if (visibleActions.length === 0) return null;

    return (
      <Dropdown drop="start">
        <Dropdown.Toggle variant="light" size="sm" className="no-arrow">
          <i className="bi bi-three-dots-vertical"></i>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {visibleActions.map((action, index) => (
            <Dropdown.Item
              key={index}
              onClick={(e) => {
                e.stopPropagation();
                action.onClick();
              }}
              disabled={(action.label === 'Scarica Report Attività' && isDownloadingReport) || action.isLoading} // <-- Verifica 'action.isLoading'
            >
              {action.isLoading ? ( // <-- Controlla la proprietà generica 'isLoading'
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2"/>
              ) : (
                <i className={`bi ${action.icon} me-2`}></i> // Mostra l'icona se non sta caricando
              )}
              {action.label}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  const renderPercorsoFormativo = () => {
    if (setShowFilterTable && typeof setShowFilterTable === 'function') {
      setShowFilterTable(false);
    }
    const contenutiMap = new Map(percorsoFormativo?.contenuti?.map(c => [c.id_contenuto, c]) || []);

    const sortContenuti = (contenuti) => {
      const findLevel = (contenuto) => {
        let level = 0;
        let current = contenuto;
        while (current.id_contenuto_propedeutico) {
          level++;
          current = contenutiMap.get(current.id_contenuto_propedeutico);
          if (!current) break;
        }
        return level;
      };

      return [...(contenuti || [])].sort((a, b) => {
        if (a.completato !== b.completato) return a.completato ? -1 : 1;

        if (a.completato) {
          return new Date(a.data_fine_prevista) - new Date(b.data_fine_prevista);
        } else {
          const levelA = findLevel(a);
          const levelB = findLevel(b);
          if (levelA !== levelB) return levelA - levelB;

          return a.id_contenuto - b.id_contenuto;
        }
      });
    };

    return (
      <div className="container-fluid px-4">
        <div className="d-flex align-items-center mb-4">
          <Button
            variant="link"
            className="text-dark p-0 me-3"
            onClick={() => {
              if (setShowFilterTable && typeof setShowFilterTable === 'function') {
                setShowFilterTable(true);
              }
              setCurrentView('list');
              setCurrentTab('contenuti');
            }}
          >
            <i className="bi bi-arrow-left fs-4"></i>
          </Button>
          <h4 className="mb-0">
            <i className="bi bi-journal-text text-primary me-2"></i>
            Percorso Formativo di <b>{selectedUserNome} {selectedUserCognome}</b>
          </h4>
        </div>

        {loadingStateClassi.isLoadingMaterialiClasseByUserId ? (
          <div className="text-center py-5">
            <Spinner animation="border" role="status" />
          </div>
        ) : percorsoFormativo && (
          <>
            <Card className="border-0 shadow-sm mb-4">
              <Card.Body className="p-4">
                <h4>{percorsoFormativo.denominazione_corso}</h4>
                <p className="text-muted mb-3">{percorsoFormativo.descrizione_corso}</p>
                <div className="d-flex flex-wrap gap-3">
                  {percorsoFormativo.data_inizio && percorsoFormativo.data_fine && (
                    <div className="text-muted">
                      <i className="bi bi-calendar3 me-2"></i>
                      {new Date(percorsoFormativo.data_inizio).toLocaleDateString()} - {new Date(percorsoFormativo.data_fine).toLocaleDateString()}
                    </div>
                  )}
                  {percorsoFormativo.denominazione && !percorsoFormativo.denominazione.includes('Classe Online - ') && (
                    <div className="text-muted">
                      <i className="bi bi-people me-2"></i>
                      Classe: {percorsoFormativo.denominazione}
                    </div>
                  )}
                </div>
              </Card.Body>
            </Card>
            <Nav variant="tabs" className="mb-4">
              <Nav.Item>
                <Nav.Link
                  active={currentTab === 'contenuti'}
                  onClick={() => setCurrentTab('contenuti')}
                >
                  <i className="bi bi-collection-play me-2"></i>
                  Contenuti del corso
                </Nav.Link>
              </Nav.Item>
            </Nav>
            {currentTab === 'contenuti' && percorsoFormativo.contenuti ? (
              <Card className="border-0 shadow-sm">
                <Card.Body>
                  {percorsoFormativo.contenuti.length > 0 ? (
                    sortContenuti(percorsoFormativo.contenuti).map((contenuto) => (
                      <div
                        key={contenuto.id_contenuto}
                        className="d-flex align-items-center p-3 border-bottom"
                      >
                        <div className="me-3">
                          {contenuto.completato ? (
                            <i className="bi bi-check-circle-fill text-success fs-5"></i>
                          ) : contenuto.id_contenuto_propedeutico &&
                            !contenutiMap.get(contenuto.id_contenuto_propedeutico)?.completato ? (
                            <i className="bi bi-lock-fill text-muted fs-5"></i>
                          ) : (
                            <i className="bi bi-circle text-muted fs-5"></i>
                          )}
                        </div>
                        <div className="flex-grow-1">
                          <div className="fw-medium">{contenuto.titolo}</div>
                          <div className="d-flex align-items-center flex-wrap gap-3 mt-1">
                            <small className="text-muted">
                              <i className="bi bi-folder2 me-1"></i>
                              Area: {contenuto.titolo_area}
                            </small>
                            <small className="text-muted">
                              <i className="bi bi-clock me-1"></i>
                              {contenuto.peso_orario}m
                            </small>
                            {contenuto.completato && contenuto.data_fine_prevista && (
                              contenuto.tipo_contenuto === 'test'
                                ?
                                contenuto.id_contenuti_test == null
                                  ?
                                  <small className="text-dark">
                                    <i className="bi bi-info-circle me-1 text-primary"></i>
                                    Test non ancora superato
                                  </small>
                                  :
                                  <small className="text-success">
                                    <i className="bi bi-check-circle me-1"></i>
                                    Test superato
                                  </small>
                                :
                                <small className="text-success">
                                  <i className="bi bi-check-circle me-1"></i>
                                  Completato il {new Date(contenuto.data_fine_prevista).toLocaleDateString()}
                                </small>
                            )}
                          </div>
                        </div>
                        <Badge bg={contenuto.opzionale ? "secondary" : "primary"} text={contenuto.opzionale ? "dark" : undefined}>
                          {contenuto.opzionale ? "Opzionale" : "Obbligatorio"}
                        </Badge>
                      </div>
                    ))
                  ) : (
                    <div className="text-center py-4">
                      <i className="bi bi-journal-x fs-1 text-muted mb-2"></i>
                      <p className="text-muted mb-0">Nessun contenuto disponibile</p>
                    </div>
                  )}
                </Card.Body>
              </Card>
            ) : null}
            {currentTab === 'calendario' && (percorsoFormativo.lezioni || percorsoFormativo.esami) && (
              <Card className="border-0 shadow-sm">
                <Card.Body>
                  {(percorsoFormativo.lezioni?.length || 0) > 0 || (percorsoFormativo.esami?.length || 0) > 0 ? (
                    <div className="row g-4">
                      {percorsoFormativo.lezioni?.map((lezione) => (
                        <div key={lezione.id_lezione} className="col-12 col-lg-6">
                        </div>
                      ))}
                      {percorsoFormativo.esami?.map((esame) => (
                        <div key={esame.id_calendario_esame} className="col-12 col-lg-6">
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-center py-4">
                      <i className="bi bi-calendar-x fs-1 text-muted mb-2"></i>
                      <p className="text-muted mb-0">Nessuna attività programmata</p>
                    </div>
                  )}
                </Card.Body>
              </Card>
            )}
          </>
        )}
      </div>
    );
  };

  return (
    <div>
      {currentView === 'percorso' ? (
        renderPercorsoFormativo()
      ) : (
        sortedRoles?.map((role) => (
          <div key={role}>
            <h4 className='mt-3 mb-1'>{formatRoleName(role)}</h4>
            {groupedUsers[role]?.map((utente) => {
              return (
                <div key={utente?.id_utente} className='card p-3 my-2 rounded'>
                  <div className={`${!isMax500px ? "d-flex justify-content-between" : ""} `}>
                    <div className={`${!isMax500px ? "d-flex gap-3" : ""} custom-card-title`}>
                      <div className={`custom-icon-container`}>
                        <i style={{ width: "45px", height: "45px" }} className={`bi custom-icon bi-person-fill bg-secondary text-dark fs-4`}></i>
                      </div>
                      <div className='align-self-center'>
                        <span className='d-block fs-5'>
                          <span className={`${isMax500px ? "d-block" : ""}`}>
                            {utente?.nome} {utente?.cognome}
                          </span>
                          
                          {/* --- MODIFICA 1: Aggiunto PARTNER alla visibilità dei badge --- */}
                          {utente?.tipo_utente === "corsista" && (userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.PARTNER) && utente.stato_pagamento && (
                            <span className={`badge ${UtilityService.getBadgeColorClass(utente.stato_pagamento)} ${!isMax500px ? "mx-1" : "me-1"}`}>
                              {UtilityService.getPaymentState(utente.stato_pagamento)}
                            </span>
                          )}
                          {utente?.tipo_utente === "corsista" && (userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.PARTNER) && (
                            <span className={`badge ${UtilityService.getBillingStatusBadgeColor(utente.stato_fatturazione)} ${!isMax500px ? "mx-1" : "me-1"}`}>
                              {UtilityService.getBillingStatusText(utente.stato_fatturazione, utente.fattura)}
                            </span>
                          )}
                          
                          {utente.tipo_utente === 'corsista' && (
                              <span className={`badge bg-${UtilityService.getVerificaStatusBadge(utente.stato_verifica_amministrativa).bg}`}>
                                {UtilityService.getVerificaStatusBadge(utente.stato_verifica_amministrativa).text}
                              </span>
                          )}
                          {utente?.esito_esame && utente.esito_esame !== 'non_svolto' && (
                            <div className={`small text-muted ${isMobile ? 'w-100 text-center' : ''}`}>
                              <i style={{ color: 'green' }} className="bi bi-award me-1"></i>
                              Esito esame: <strong>{utente.esito_esame}</strong>
                            </div>
                          )}
                          {/* Mostra informazioni prenotazione esame se presente */}
                          {utente?.prenotazione_esame && utente.prenotazione_esame.prenotato === 1 && (
                            <div className={`${isMobile ? 'w-100 text-center' : ''} mt-2`}>
                              <Badge bg="info" className="me-2">
                                <i className="bi bi-calendar-check me-1"></i>
                                Esame prenotato
                              </Badge>
                              {utente.prenotazione_esame.data_esame && (
                                <span className="text-muted" style={{ fontSize: '0.75rem' }}>
                                  Data: {moment(utente.prenotazione_esame.data_esame).format('DD/MM/YYYY')}
                                  {utente.prenotazione_esame.ora_inizio && utente.prenotazione_esame.ora_fine && (
                                    <> - {utente.prenotazione_esame.ora_inizio.substring(0, 5)} / {utente.prenotazione_esame.ora_fine.substring(0, 5)}</>
                                  )}
                                </span>
                              )}
                            </div>
                          )}
                          
                          {/* --- MODIFICA 2: Aggiunto PARTNER alla visibilità dei link Statino e Attestato --- */}
                          {utente?.tipo_utente === "corsista" && utente.path_statino && (userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.PARTNER) && (
                            <span> <a
                              href={utente.path_statino}
                              className={`btn btn-outline-info btn-sm ${isMobile && 'w-100 text-center'}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <i className="bi bi-file-earmark-arrow-down me-1"></i>
                              Scarica Statino
                            </a></span>
                          )}
                          {utente?.tipo_utente === "corsista" && utente.path_attestato_orizzontale && (userLoggedIn?.role === ROLES.ADMIN || userLoggedIn?.role === ROLES.DEVELOPER || userLoggedIn?.role === ROLES.PARTNER) && (
                            <span> <a
                              href={utente.path_attestato_orizzontale}
                              className={`btn btn-outline-success btn-sm ${isMobile && 'w-100 text-center'}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <i className="bi bi-file-earmark-text me-1"></i>
                              Scarica Attestato
                            </a></span>
                          )}
                        </span>
                        
                        {utente?.id_utente && (
                          <span className='text-muted small d-block'>
                            <i className="bi bi-person-badge me-1"></i>
                            id: {utente.id_utente}
                          </span>
                        )}
                        {utente?.agenzia && (
                          <span className='text-muted small d-block'>
                            <i className="bi bi-building me-1"></i>
                            Agenzia: {utente.agenzia}
                          </span>
                        )}
                        <span className='text-muted small d-block'><i className="bi bi-envelope"></i> {utente?.username}</span>
                        {utente?.data_iscrizione && (
                          <span className='text-muted small d-block'>
                            <i className="bi bi-calendar-event me-1"></i>
                            {utente.tipo_utente === "corsista" ? "Iscritto" : "Assegnato"} il: {utente.data_accettazione_condizioni !== null ? UtilityService.formatDate(utente.data_accettazione_condizioni) : UtilityService.formatDate(utente.data_iscrizione)}
                          </span>
                        )}
                        {utente.prezzo_assegnato != null && (
                                    <span className='text-muted small d-block'>
                                        <i className="bi bi-cart3 me-1"></i>
                                        Prezzo assegnato: 
                                        {parseFloat(utente.sconto) > 0 && 
                                            <del className="mx-1">{parseFloat(utente.prezzo).toFixed(2)}€</del>
                                        }
                                        <strong> {parseFloat(utente.prezzo_assegnato).toFixed(2)}€</strong>
                                    </span>
                        )}
                        {utente.tipo_utente === "corsista" && utente.is_bonifico_corsista == 1 && (
                          <span className='text-muted small d-block'>
                            <i className="bi bi-bank me-1"></i>
                            Pagamento: Bonifico
                          </span>
                        )}
                        {utente.tipo_utente === "corsista" && utente.is_stripe == 1 && (
                          <span className='text-muted small d-block'>
                            <i className="bi bi-credit-card me-1"></i>
                            Pagamento: Elettronico
                          </span>
                        )}
                        {utente.tipo_utente === "corsista" && utente.is_voucher == 1 && (
                          <span className='text-muted small d-block'>
                            <i className="bi bi-tag me-1"></i>
                            Pagamento: Voucher
                          </span>
                        )}
{utente.tipo_utente === 'corsista' && utente.stato_pagamento === 'Pagato' && (
    <span className={`small d-block fst-italic ${
        // Modifica la condizione: usa ! per verificare se è 0, null, undefined, ecc.
        !utente.pagamento_partner ? 'text-danger fw-bold' : 'text-muted'
    }`}>
        <i className="bi bi-wallet2 me-1"></i>
        Pagato da: {getFontePagamentoText(utente.pagamento_partner)}
    </span>
)}
                        {utente.tipo_utente === "corsista" && (
                          <div className="mt-2">
                            <small className="text-muted d-block mb-1">
                              Stato corso: {utente.ore_seguite_corso || 0} su {utente.ore_totali_corso || 0} ore
                              {(utente.ore_seguite_corso || 0) > 0 && (
                                <Button
                                  variant="primary"
                                  size="sm"
                                  onClick={() => handleShowPercorsoFormativo(utente.id_classe, utente.id_utente, utente.id_classe_utente, utente.nome, utente.cognome)}
                                  style={{ height: '20px', left: '10px', position: 'relative' }}
                                  className={`d-inline-flex align-items-center px-2 ${isMobile && 'w-100 justify-content-center'}`}
                                >
                                  <small>Visualizza</small>
                                </Button>
                              )}
                            </small>
                            {(() => {
                              const oreSeguite = utente.ore_seguite_corso || 0;
                              const oreTotali = utente.ore_totali_corso || 0;
                              let percentuale = (oreTotali > 0) ? Math.round((oreSeguite / oreTotali) * 100) : 0;
                              
                              // Verifica che tutti i contenuti obbligatori siano completati correttamente
                              // Se non tutti i contenuti hanno data_inizio IS NOT NULL e completato = 1, limita a 99%
                              if (utente.totale_contenuti_obbligatori !== undefined && 
                                  utente.contenuti_completati_correttamente !== undefined &&
                                  utente.contenuti_completati_correttamente < utente.totale_contenuti_obbligatori) {
                                percentuale = Math.min(99, percentuale);
                              }
                              
                              const percentualeFinale = Math.min(100, percentuale);
                              
                              return (
                                <ProgressBar
                                  now={percentualeFinale}
                                  label={`${percentualeFinale}%`}
                                  striped
                                  animated
                                  variant={percentualeFinale >= 100 ? 'success' : 'primary'}
                                  style={{ height: '1rem' }}
                                />
                              );
                            })()}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className='align-self-center'>
                      {renderActions(utente)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        ))
      )}
      <CustomModal
        show={modalStateUtenti.showModalInfoUtente}
        onHide={handleCloseModal}
        headerText="Anagrafica utente"
        size={"lg"}
        body={
          <InputUserInfo 
            userData={selectedUtente} 
            setIsEditMode={() => {}}
            onSaveUserInfo={handleCloseModal}
            isUpdateUserFromModal={true}
            onHide={handleCloseModal}
            printAllUtenti={onRefreshUsers || (() => {})}
          />
        }
        closeButton={true}
        hideSaveBtn={true}
        onUndoChanges={handleCloseModal}
      />
    </div>
  );
};

export default UsersToCourseManager;